import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import MyContext from '../../Context/AppContext';

const BackDropLoader = () => {

    const { isBackdropEnabled } = React.useContext(MyContext);
    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={isBackdropEnabled}
        >
            <div className='backdropLoaderDiv'>
                <CircularProgress color="inherit" />
                <span style={{ marginLeft: '10px' }}>Please wait...</span>
            </div>
        </Backdrop>
    )
}

export default BackDropLoader